import React from 'react';
import useCountDown from '../../../customHooks/useCountDown';

const initialTime = 5 * 1000; // initial time in milliseconds, defaults to 60000
const interval = 1000; // interval to change remaining time amount, defaults to 1000

const SkipButton = ({ seconds, playing, onSkipBtnClick, thumbnail }) => {
  const [timeLeft, { start, pause, resume, reset, isOver }] = useCountDown(initialTime, interval);
  const [over, setOver] = React.useState(false);

  React.useEffect(() => {
    if (seconds > 0) {
      reset();
      start(seconds * 1000);
    }
  }, [seconds]);

  React.useEffect(() => {
    if (!playing) {
      pause();
    } else {
      resume();
    }
  }, [playing]);

  // React.useEffect(() => {
  //   if (isOver()) {
  //     setOver(true);
  //     reset();
  //   } else {
  //     // console.log('over checked' + setOver());
  //   }
  // }, [timeLeft]);

  return (
    <>
      <div className={`clr_player__skip ${timeLeft / 1000 <= 0 ? 'active' : ''}`}>
        {timeLeft / 1000 > 0 && (
          <span className="clr_player_skipCount">
            {(timeLeft / 1000).toString().padStart(2, '0')}
          </span>
        )}

        {timeLeft / 1000 <= 0 && (
          <span
            className="clr_player_skipBttn cursorPointer"
            onClick={() => {
              onSkipBtnClick();
            }}
            title={'Skip Ad'}
          >
            Skip Ad
            <svg
              stroke="currentColor"
              fill="none"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke-linecap="round"
              stroke-linejoin="round"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <desc></desc>
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M4 5v14l12 -7z"></path>
              <line x1="20" y1="5" x2="20" y2="19"></line>
            </svg>
          </span>
        )}
      </div>
    </>
  );
};
export default SkipButton;
